import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import { $each } from 'core/dom';
import $events from 'wee-events';

export default new RouteHandler({
    init() {
        const $videoEmbed = $(':video-embed');
        const players = [];
        const embedIDs = [];
        const ytIDs = [];
        const $playIcon = $(':video-play-icon');
        const $playButton = $(':video-play-btn');
        let scrollTimer = '';
        let lastScrollFireTime = 0;
        window.videoApiLoaded = [];
        window.videoApiLoaded.youtube = false;
        window.onYouTubeIframeAPIReady = function () {
            document.dispatchEvent(new CustomEvent('onYouTubeIframeAPIReady', {
            }));
        };

        $each(':video-embed', (el) => {
            embedIDs.push(el.id);
            ytIDs.push($(el).data('yt-id'));
        });

        if (window.videoApiLoaded.youtube === false && embedIDs.length > 0) {
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.videoApiLoaded.youtube = true;
        }

        function loadVideo(ytID) {
            players.forEach((playerObj) => {
                if (playerObj[ytID]) {
                    playerObj[ytID].loadVideoById(ytID);
                }
            });
        }

        function cueVideos(ytID) {
            players.forEach((playerObj) => {
                if (playerObj[ytID]) {
                    playerObj[ytID].cueVideoById(ytID);
                }
            });
        }

        function playVideo(ytID) {
            players.forEach((playerObj) => {
                if (playerObj[ytID]) {
                    playerObj[ytID].playVideo();
                }
            });
        }

        function pauseVideo(ytID) {
            players.forEach((playerObj) => {
                if (playerObj[ytID]) {
                    playerObj[ytID].pauseVideo();
                }
            });
        }

        function onPlayerStateChange(e) {
            // Video end event
            if (e.data === 0) {
                const iframe = e.target.h;
                const $overlay = $(iframe).siblings('.js-overlay');
                $overlay.show();
                iframe.tabIndex = -1;
            }
        }

        function onPlayerReady(e) {
            const iframeObject = e.target;
            const ytID = $(iframeObject.h).data('yt-id');
            const player = {
                [ytID]: iframeObject,
            };

            players.push(player);

            ytIDs.forEach((el) => {
                cueVideos(el);
            });

            function videoScroll() {
                const windowHeight = window.innerHeight;

                $each($videoEmbed, (el) => {
                    // targetting iframe by ID as it is dynamically added
                    const iframeID = el.id;
                    const iframe = document.getElementById(iframeID);
                    const videoHeight = iframe.clientHeight;
                    const contentSection = $(iframe).closest('.js-content');
                    const $overlay = $(iframe).siblings('.js-overlay');
                    const currentYtID = $(iframe).data('yt-id');
                    const videoClientRect = $(iframe)[0].getBoundingClientRect().top;

                    function inFrameCheck() {
                        if (videoClientRect <= ((windowHeight) - (videoHeight * 0.5))
                            && videoClientRect >= (0 - (videoHeight * 0.5))) {
                            players.forEach((playerObj) => {
                                if (playerObj[currentYtID]) {
                                    const status = playerObj[currentYtID].getPlayerState();
                                    // play if not already playing, paused by user,
                                    // scrolled out of view or ended
                                    if (status === 2) {
                                        pauseVideo(currentYtID);
                                    } else if (status !== 1 || status !== 0) {
                                        $overlay.hide();
                                        playVideo(currentYtID);
                                    }
                                }
                            });
                        } else {
                            $overlay.show();
                            pauseVideo(currentYtID);
                        }
                    }

                    if (contentSection.length) {
                        if ($(contentSection).hasClass('-expanded')) {
                            inFrameCheck();
                        }
                    } else {
                        inFrameCheck();
                    }
                });
            }

            function showVideo($overlay, $iframe, currentYtID) {
                $overlay.hide();
                $iframe[0].tabIndex = 0;
                loadVideo(currentYtID);
            }

            $events.on($playIcon, 'click', (ev, el) => {
                const $overlay = $(el).parents(':overlay');
                const $iframe = $(el).parents(':overlay').siblings('.js-video-embed');
                const currentYtID = $iframe.data('yt-id');

                showVideo($overlay, $iframe, currentYtID);
            });

            $events.on($playButton, 'click', (ev, el) => {
                const $overlay = $(el).parent().siblings('.js-video-wrapper').find('.js-overlay');
                const $iframe = $(el).parent().siblings('.js-video-wrapper').find('.js-video-embed');
                const currentYtID = $iframe.data('yt-id');

                showVideo($overlay, $iframe, currentYtID);
            });

            // Event throttled
            if ($videoEmbed.hasClass('-scroll-play')) {
                $events.on(window, 'scroll', () => {
                    const minScrollTime = 500;
                    const now = new Date().getTime();

                    if (!scrollTimer) {
                        if (now - lastScrollFireTime > (3 * minScrollTime)) {
                            videoScroll();
                            lastScrollFireTime = now;
                        }
                        scrollTimer = setTimeout(() => {
                            scrollTimer = null;
                            lastScrollFireTime = new Date().getTime();
                            videoScroll();
                        }, minScrollTime);
                    }
                });
            }
        }

        document.addEventListener('onYouTubeIframeAPIReady', () => {
            // Create players
            embedIDs.forEach((iframeId) => {
                new YT.Player(iframeId, {
                    height: '100%',
                    width: '100%',
                    playerVars: {
                        modestbranding: 1,
                        playsinline: 1,
                        fs: 0,
                        cc_load_policy: 1,
                    },
                    events: {
                        onReady: onPlayerReady,
                        onStateChange: onPlayerStateChange,
                    },
                });
            });
        });
    },
});
